/// <reference path="DOMAttached.js" />
/// <reference path="ProgressIndicator.js" />

class DesignstudioEditor extends DOMAttached {
	constructor(el, options) {
		super(el, options);
		this.progressIndicator = new ProgressIndicator(this.el);
		this.progressIndicator.showProgressIndicator();
		var svgPath = options.svgPath;
		var svgContent = "";

		// get content of svg file
		if (svgPath != "") {
			jQuery.get(svgPath, function(data) {
				var svgContent = new XMLSerializer().serializeToString(data.documentElement);
				initializeDesignStudio(options, svgContent);

			});
		} else {
			// should never arrive here...?
		}

		this.progressIndicator.hideProgressIndicator();
	}
}
